// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"e0389467","54":"45d30f57","74":"16aea9ed","130":"0977ba5f","146":"2243b9b6","193":"00fffbdb","209":"76646c90","218":"23d2346c","277":"953f92f0","392":"b97d1d64","496":"91835723","762":"528f60d8","848":"616c3e52","910":"99b53f45","960":"02caa135"}[chunkId] + ".chunk.js";
};